/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Brand_Pill_LabelInputs */

const he_notifications_brand_pill_label = /** @type {(inputs: Notifications_Brand_Pill_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מותג`)
};

const en_notifications_brand_pill_label = /** @type {(inputs: Notifications_Brand_Pill_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brand`)
};

/**
* | output |
* | --- |
* | "Brand" |
*
* @param {Notifications_Brand_Pill_LabelInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_brand_pill_label = /** @type {((inputs?: Notifications_Brand_Pill_LabelInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Brand_Pill_LabelInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_brand_pill_label(inputs)
	return en_notifications_brand_pill_label(inputs)
});